<template>
  <div id="tb">
    <van-sticky>
      <div class="table-title flex-center">
        <div
          class="col title flex-center"
          :class="{ 'first-title': index === 0 }"
          :style="{ flex: `0 0 ${index === 0 ? '25%' : colWidth[total]}` }"
          v-for="(title, index) in realColunm"
          :key="title.title"
        >
          {{ title.title }}
          <div style="font-size: 9px;">
            {{ title.format || '' }}
          </div>
        </div>
      </div>
    </van-sticky>

    <div>
      <div
        class="flex-center row"
        v-for="(item, index) in dataSource"
        :class="{ 'bg-color': index % 2 != 0 }"
        :key="index"
      >
        <div
          class="col title flex-center"
          v-for="(tag, cellIndex) in realColunm"
          :class="{ 'first-row': cellIndex === 0 }"
          :style="{ flex: `0 0 ${cellIndex === 0 ? '25%' : colWidth[total]}` }"
          @click="clickItem(item, cellIndex)"
          :key="tag.title"
        >
          <!-- 每一个第一个 -->
          <div class="flex-center first-cell" v-if="cellIndex === 0">
            <img
              style="width: 20px;height: 20px;"
              :src="iconList[index].icon"
              v-if="index < 3"
            />
            <div
              style="font-weight: bold;font-size: 12px;color: #969799;width: 26px;text-align:center;"
              v-if="index >= 3"
            >
              {{ index + 1 }}
            </div>
            <div
              class="van-multi-ellipsis--l2"
              :class="{
                first: index === 0,
                second: index === 1,
                thrid: index === 2,
              }"
            >
              {{ item[tag.key] || 0 }}
            </div>
          </div>
          <!-- 第一个后面的-->
          <div v-if="cellIndex !== 0">
            <div
              v-if="!tag.subtitle"
              class="van-multi-ellipsis--l2"
              style="text-align:right;"
            >
              {{ item[tag.key] || 0 }}
            </div>
            <div
              v-if="tag.subtitle"
              class="van-multi-ellipsis--l2"
              style="text-align:right;"
            >
              {{ item[tag.key].title || 0 }}
            </div>
            <div style="font-size: 9px;color: #7D7E80;text-align:right;">
              {{ item[tag.key].subtitle || '' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-empty description="暂无内容" v-if="!dataSource.length" />
  </div>
</template>

<script>
export default {
  props: {
    calcHeight: {
      type: Boolean,
      default: false,
    },
    finished: {
      type: Boolean,
      default: false,
    },
    columnData: {
      type: Array,
      default: function() {
        return []
      },
    },
    dataSource: {
      type: Array,
      default: function() {
        return []
      },
    },
  },
  watch: {
    columnData: {
      handler: function(val) {
        console.log('change', val)
        this.realColunm = val.filter((item) => item.active)
        this.total = this.realColunm.length - 1
      },
      deep: true,
    },
  },
  data() {
    return {
      realColunm: [],
      total: 0,
      tbHeight: 0,
      colWidth: ['100%', '70%', '35%', '23%', '18%'],
      iconList: [
        {
          icon:
            'https://img.esenyun.com/images/20200716/aeff53b801994c5cafffebbfde4483dc.png',
          color: '#D53422',
        },
        {
          icon:
            'https://img.esenyun.com/images/20200716/8a2f2735b8ff404f99b1625e9731c764.png',
          color: '#E1A200',
        },
        {
          icon:
            'https://img.esenyun.com/images/20200716/6e9a0d4f3b6f4da3804a07d016e3cf5e.png',
          color: '#707897',
        },
      ],
    }
  },
  async mounted() {
    this.realColunm = this.columnData.filter((item) => item.active)
    this.total = this.realColunm.length - 1
  },
  methods: {
    clickItem(item) {
      this.$emit('item', item)
    },
  },
}
</script>

<style lang="less" scoped>
.first {
  color: #d53422;
}
.second {
  color: #e1a200;
}
.third {
  color: #707897;
}
.table-title {
  height: 44px;
  background: #eff1f3;
  font-size: 11px;
  color: #4a4a4a;
}
.title {
  position: relative;
  flex-direction: column;
  align-items: flex-end;
}
.col {
  flex: 0 0 18%;
  height: 100%;
  justify-content: center;
}
.first-title {
  flex: 0 0 25% !important;
  padding-left: 26px;
  align-items: flex-start;
}
.first-row {
  flex: 0 0 25% !important;
  align-items: flex-start;
}
.row {
  background: #fff;
  font-size: 14px;
  color: #000;
  height: 58px;
}
.first-cell {
  justify-content: center;
  font-size: 13px;
  img {
    margin: 0 2px 0 4px;
  }
  div {
    width: calc(100% - 26px);
  }
}
.bg-color {
  background: #f7f8f9;
}
.empty {
  background: #fff;
}
</style>
